var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13.5H2.75C2.3125 13.5 2 13.8125 2 14.25C2 14.6875 2.3125 15 2.75 15H13.25C13.6562 15 14 14.6875 14 14.25C14 13.8438 13.6562 13.5 13.25 13.5ZM11.4375 6.5L8.75 9.375V1.78125C8.75 1.34375 8.40625 1 8 1C7.5625 1 7.25 1.34375 7.25 1.78125V9.375L4.53125 6.5C4.375 6.34375 4.1875 6.28125 4 6.28125C3.8125 6.28125 3.625 6.34375 3.46875 6.46875C3.15625 6.75 3.15625 7.21875 3.4375 7.53125L7.4375 11.7812C7.71875 12.0938 8.25 12.0938 8.53125 11.7812L12.5312 7.53125C12.8125 7.21875 12.8125 6.75 12.5 6.46875C12.1875 6.1875 11.7188 6.1875 11.4375 6.5Z",
    fill: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHtml);
export default __webpack_public_path__ + "static/media/download_html.71a31a9a986ec12f603c7ee49f491c0b.svg";
export { ForwardRef as ReactComponent };